(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  class Axis {
    /**
     * Initializes a new instance of the class with default axis and content direction.
     *
     * @constructor
     * @property {string} axis - The axis of the carousel, default is 'x'.
     * @property {string} contentDirection - The content direction, default is 'ltr'.
     */
    constructor() {
      this.axis = 'x';
      this.contentDirection = 'ltr';
    }

    /**
     * Initializes the axis configuration for the carousel.
     *
     * @param {'x'|'y'} axis - The axis along which the carousel scrolls ('x' for horizontal, 'y' for vertical).
     * @param {'ltr'|'rtl'} contentDirection - The content direction ('ltr' for left-to-right, 'rtl' for right-to-left).
     */
    initialize(axis, contentDirection) {
      this.axis = axis;
      this.contentDirection = contentDirection;
      this.isRightToLeft = contentDirection === 'rtl';
      this.isVertical = axis === 'y';
      this.scroll = this.isVertical ? 'y' : 'x';
      this.cross = this.isVertical ? 'x' : 'y';
      this.sign = !this.isVertical && this.isRightToLeft ? -1 : 1;
    }

    /**
     * Determines the starting edge of the carousel based on orientation and direction.
     *
     * @returns {string} The starting edge: 'top' if vertical, 'right' if right-to-left, otherwise 'left'.
     */
    getStartEdge() {
      if (this.isVertical) {
        return 'top';
      }

      return this.isRightToLeft ? 'right' : 'left';
    }

    /**
     * Returns the name of the end edge based on the orientation and direction.
     *
     * @returns {string} The end edge: 'bottom' if vertical, 'left' if right-to-left, otherwise 'right'.
     */
    getEndEdge() {
      if (this.isVertical) {
        return 'bottom';
      }

      return this.isRightToLeft ? 'left' : 'right';
    }

    /**
     * Measures the size of a DOM node rectangle based on the orientation.
     * Returns the height if the carousel is vertical, otherwise returns the width.
     *
     * @param {DOMRect} nodeRect - The bounding rectangle of the DOM node.
     * @returns {number} The measured size (height or width) of the node.
     */
    measureSize(nodeRect) {
      return this.isVertical ? nodeRect.height : nodeRect.width;
    }

    /**
     * Calculates the direction by multiplying the input value by the current sign.
     * @param {number} number - The value to apply the direction to.
     * @returns {number} The result of n multiplied by the sign.
     */
    direction(number) {
      return number * this.sign;
    }

    /**
     * Returns the current scroll value.
     * @returns {string} The current scroll value.
     */
    getScroll() {
      return this.scroll;
    }

    /**
     * Returns the value of the cross property.
     * @returns {string} The current value of the cross property.
     */
    getCross() {
      return this.cross;
    }
  }

  global.NewHomeSource.Carousel.Axis = Axis;
}(window));
